<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<div class="sidebar1">
<div class="sidebar2">
<p class="half-title"><a id="page_i"></a><span class="small1">TO TRY</span><br/>MEN’S SOULS</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?11be9216